module.exports = __webpack_public_path__ + "static/media/210.f0b85725.jpg";